import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "min-h-screen bg-gray-100 flex items-center justify-center"
}

import {
  ref,
  onBeforeMount,
  onUnmounted,
} from 'vue';
import { useRouter } from 'vue-router';
import useUserStore from '@/store/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfileLayout',
  setup(__props) {

const router = useRouter();
const {
  usersDoGetMyUser,
  resetStore,
} = useUserStore();

/*
  Data
*/
const isLoading = ref(true);
const myProfile = ref({});

/*
  Methods
*/
const redirectDashboard = ((error: string) => router.push({
  name: 'DashboardPage',
  query: {
    message: 'Could not load profile. Please try again.',
    detail: error,
    type: 'error',
  },
}));

const resetFields = async () => {
  isLoading.value = true;
  await usersDoGetMyUser()
    .then((response: any) => {
      if (response === undefined) {
        redirectDashboard('Profile unavailable');
      }
      myProfile.value = response;
      isLoading.value = false;
    }).catch((error: any) => redirectDashboard(error.toString()));
};

/*
  Hooks
*/
onBeforeMount(async () => {
  await resetFields();
});
onUnmounted(() => {
  resetStore();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_RouterView, {
          modelValue: myProfile.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((myProfile).value = $event)),
          "onUpdate:myProfile": resetFields
        }, null, 8, ["modelValue"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-teal-600" }, null, -1)
      ])))
}
}

})